exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-slider a,.app-slider a .slider-img{display:block;width:100%}.app-slider .slick-dots li,.app-slider.slick-slider .slick-dots li.slick-active button,.app-slider.slick-slider .slick-dots li button{width:8px;height:8px;border-radius:50%;background-color:#d7d7d7}.app-slider.slick-slider .slick-dots li.slick-active button{width:8px;background:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./src/styles/slider.css
// module id = 808
// module chunks = 0